
const docx = require("docx");
const { Paragraph, TextRun } = docx;

export const __Breaker = () => new Paragraph({
    children: [
        new TextRun({ text: "\n", break: 1 }),
    ],
})
